module.exports = __webpack_public_path__ + "fonts/Roboto-BlackItalic.65f2f623.woff";